import { render, staticRenderFns } from "./explainer-change-request-form.vue?vue&type=template&id=5cbf7ccc&scoped=true&"
import script from "./explainer-change-request-form.vue?vue&type=script&lang=js&"
export * from "./explainer-change-request-form.vue?vue&type=script&lang=js&"
import style0 from "./explainer-change-request-form.vue?vue&type=style&index=0&id=5cbf7ccc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbf7ccc",
  null
  
)

export default component.exports